{
  "version": 1,
  "asset_id": "25e18a71-3171-40f5-a08b-6a762f660b39",
  "project_id": "ba939065-ecb3-4567-a218-3200eee84f15",
  "url": "/__l5e/assets-v1/25e18a71-3171-40f5-a08b-6a762f660b39/form-8821.jpg",
  "r2_key": "a/v1/ba939065-ecb3-4567-a218-3200eee84f15/25e18a71-3171-40f5-a08b-6a762f660b39/form-8821.jpg",
  "original_filename": "form-8821.jpg",
  "size": 143491,
  "content_type": "image/jpeg",
  "created_at": "2026-06-15T15:39:06Z"
}
